module.exports = __webpack_public_path__ + "img/icon-mail.ededeed3.svg";